export interface Citation {
  anchor: string;
  source: string;
  title: string;
}

export function formatBotResponse(
  content: string,
  citations?: Citation[],
): string {

  if (!citations || citations.length === 0) {
    return content;
  }

  let result = content;
  
  citations.forEach(citation => {
    const re = new RegExp(`\\[${citation.anchor}\\]`, 'g');
    result = result.replace(re, `[\\[${citation.anchor}\\]](${citation.source})`);
  });

  return result;
}